/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ButtonBase } from '@mui/material';

import { Namespaces } from '../../../../i18n';
import { createBackOrgButtonStyles } from './BackOrgButton.styles';

type BackOrgButtonProps = {
  className?: string;
  onClick: () => any;
  name: string;
};

export const BackOrgButton = memo<BackOrgButtonProps>(props => {
  const { t } = useTranslation(Namespaces.Common);
  const { className = '', onClick, name } = props;
  const classes = createBackOrgButtonStyles();
  return (
    <ButtonBase className={className} classes={{ root: classes.root }} onClick={onClick}>
      <div className={classes.icon}>
        <ArrowBackIcon />
      </div>
      <div className={classes.description}>{t('label.organization')}</div>
      <div className={classes.name}>{name}</div>
    </ButtonBase>
  );
});
